import * as React from "react";
import { get } from "react-hook-form";
import { InputBlock } from "main/components/form/InputBlock";

export interface IProps {
  defaultValue?: string;
  isRequired?: boolean;
  isReset?: boolean;
  errors?: any;
}

export const PasswordField: React.FC<IProps> = (
  props: IProps,
): React.ReactElement => {
  const { isRequired, isReset, defaultValue, errors } = props;
  const fieldName = "password";
  const label = isReset ? "newPassword" : "password";

  return (
    <InputBlock
      namespace="user"
      label={label}
      input={{
        name: fieldName,
        type: "password",
      }}
      defaultValue={defaultValue}
      error={get(errors, fieldName)}
      showRequiredLabel={isRequired}
    />
  );
};
